export const optaApi = {
	contestants: {
		homeIdentifier: "home",
		awayIdentifier: "away"
	},
	matchStatus: {
		completed: 0,
		upcoming: 1,
		live: 2
	},
	periodType: {
		firstHalf: 1,
		secondHalf: 2,
		extraTimeFirstHalf: 3,
		extraTimeSecondHalf: 4,
		penaltyShootout: 5,
		halfTime: 10,
		endSecondHalfBeforeExtraTime: 11,
		extraTimeHalfTime: 12,
		endExtraTimeBeforePenalties: 13,
		fullTime: 14,
		preMatch: 16,
	}
};

export const sitecoreLinkTypes = {
	external: "external",
	internal: "internal"
};

/* TODO: This needs all country falgs and SWE currently SWE is Scotlands flag for testing */
// export const flags = {
// 	SWE: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAcCAYAAAD815boAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQFSURBVHgBxZd5TFRXFMa/N8xAZgihKThQacvAtJUJ0z2lrYmxVVu1dE/TDWvtZlNrUmvTNDbGLRoS1MSFmEA0xigGGTVBY9x3oyZqFKMssugwiKgIgs6ooI7nPPMIyJt370PU3z+zvHtnvpxz7znfUcJEc9stLN5QDd/+BjxJ4hxW/DoyHTnDUuGIier6XmGR2ofA5RD+LjyBcn87Hjcj30jGlG89cD4V0+tZD5EaJXsDKNxSh8YrN/CocSU5MGOMF1mDno64Rlck09RyEwWba7GGBD8KOLW/UGq/G/q8+t6IiCI16pquY0L+cdRfCqK/GPqKE7N/9CIhLlq4dvXueigNzaFwSoJdavGyrXW4QBHuK6lJsZTaTLxtkFqNsrqryC2pxEl6jTrY8f6MaKsFL6fFQ1GUiJv4+YjXkxC8eQcVAXMXi9M5frQbc8Z5kZ4ca7j2Wug28tZWYmZROS623g+I4vlts5pujuakL19C9lvPQMTZpiD+XVqG8nqx2OGvOTH1+0wk6dza7ty+E0bpofOYSwLbSWh3ukRqcLT++zoDMkfAd6ABBZtqqAr0PgLPDXBg1g+U2owE4e+coJTOX1eFY9Wtus97iWRsURZM/PQFjB3hQozNAiNar3dgycZaFO32q5/VgjwqHT99kAZrlGK4l1O7iJpI0S6/4TpdkRoczX++GoRRbyZDBDeCFTv8+P2jdAyIN04t/2HJvgAWlVaj9VoHRBiK1MjOGohJX7wodQREnPK3IXdNBY7XXJXeIyWS4V46nqLEqbQoCszCqc3fWI2VO/2m90qL1OBozhzrxWCP+EJobDjciNziCrSFOtEXLCbXw04RNRvHjs67cNit6CvSkYymW/5Hthvj6NaKbrwebFaWbzvXVQXMICXyPSrI/3/jwbP9cHECzSFMLijDabpAshiKdFGvnZbjwTsZiRDBt7b0UCNF2iVVBdZTI1iyqVbKDuqK5HP384dpVPPcwoLcFuykYl6DVWRA2FDF2W2010WVwA1REWCzsox86+o99TAlcog3EdNzMjFQIhrF5DV57NAryGaqwLlLIUzMP0a2MGgskn90GtmoIZni1J6m8SLPV4kjZ1qEaz97N0VtsTJHgA12IRntB+2gkvXX9rDe8KNHC0WMW5lvfwBhE9XVEWPFhI/dqhcQHR+9oVAhzxZ2CmwUw5vmratUO0dfSUm0YwpViWGvOoVruw+FwvHhKNmn+eurUFYr32tFjCbPOpm8q8wR4KEwosh2amF5vipqaedVQ9rf2Gga4CPAjl1UBXRF8jyzsPTMQ6VWFvXCUjXhqhKJHiK7Dz+Pm88Hp+DPT/SrgCqSI7aAIle8J4BwuP9TK0t8rE31B2OGp/awg/cAKD2/aLKBNhYAAAAASUVORK5CYII=",
// 	USA: "data:image/jpeg;base64,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",
// 	PLACEHOLDER: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAoCAYAAACiu5n/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGvSURBVHgB5dq7CoMwFIDhYxAqCOqis+//Up1cnLwg6GQbwXIUUxOTE5P2H0rpRUw/a5NiUFXVEwBK+I+e4fumjOMYxnGELMvg8XjALzVNEzRNA1EUwTAMJR8wpGm6PLA+kSQJBEEAPjfPM3Rdt4F8DxjY+gL+QJ7ny/26rpdPxtf4vvMx8Iqi2By1IX4hY8xr7SPVfezojT5qf1PFhaIN+KIto4pjZxt0WVtWFReCRK5pq6riToVxLmhfUcVJCePu0tZRxSkJ42xq66rilIVx1NqmVHGXhXEU2iZVcVrCOFPaFKqb/QTD6WhTqeKMCeNUtalVN/sGhMlo21DFkQjjRNo8W6o48gGvrdp9339E+eC5qs0pKukhvc+FlZa1Ae+/q3fNyckPadEZmGvfMScnFZY5A9tegZEIK/8LYXEFZlxY53fVhrYxYWPrVWJtI8IUsyUqbS1h8pUNgfZlYZtzYJPaysI2VzY4U9pKwrZXNkfpaksJ36UqSkf7VNgFVVFXtIXCrqmKUtU+FHZZVZSs9kbYF1VRMtofYR9VRX3TXoTbtv25i1qOtHnBv1229AL4BcM3OhYPgAAAAABJRU5ErkJggg=="
// };

export const experienceEditorImages = {
	editPencil: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEBLAEsAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCAAiAB4DASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD+/iiivFfjf8cPDXwS8NxalqVvda94m1mYaZ4L8E6SUfXPFuv3BEVjptlGxxBBJcvEl3qEoMNlAZJ2WQRlDvhsNXxlelhcNSlWr1pKFOnHeTerbbajGMUnKc5NQhFSnOSim1jiMRRwtGpiMRUjSo0o806kr2S2SSSblKTajGMU5Tk1GKcmk/aqK/mk1e5/ag/aG/ab0/xh8EPEmnr8UfDvj/wnpfxKt5/EWo6ponw08OaU2rXDweD9QtrOxsb3wlr0N/cW/iayvNOF9p+qaPpJt7y9iu5hbf0t1wNZrhc1zfKM2yfE5XXyutQjSq1Zxq4bMcNiabrYfF4OtCKhUp1KPs6j5JVIwVWEJVPaqpTp/ZZ3kfD2D4c4M4j4e40yjiqlxXluLxWOy/BUauFzPhjMMvrUcNjMszfCVqtSrSksTOtRwtarHDTxaweIxFPDRwksLiMTyfjrxZZeBvCHiDxZqDRrbaJp0t3tmkWKOW4YrBZW7SMyqn2q8mt7dSWHzSgDnFfz+eINW/aX/aG+Ner+AfD+i6lYfFzxfAbfW/ijJqGl3vhD4QfCPWYPMi0XwLdaTe3q6Nqt3oVy6eJLnybHxFeand6jYBblfKV/6B/Gfgzwx8Q/DOq+DfGWlRa34a1uKCHVNLmnu7aO7jtru3voFaexuLW7j8u7tbeZWhuI23RgElCymLwn4D8H+BbNbDwl4e03Q7dYo4CbSEtcyxRACNLi+naa9uggUYNzcSnIznPNfbcOcRYPh7D4yrHLoY3NMRenh6mIinhsPTjGnKlKVqvNWj7X2k6+EnR9lX9nh1Oq4RqU5flmfZFis8r4SnLHTwmXULTrU8PJrEV5ylNVYq9NxpP2ShGjioVfa0eeu4U1OUKkfJv2av2bPh/+zH8PbTwR4Jso3vJyl54n8Szxq2r+JtYK/vr3ULtt08qK7SG2geRo4BJK8aI88u76Goor5rGYzFZhiq+NxtepicViakqtevVk5VKk5O7cm/uSVoxilGKUUkvfwuFw+Bw9HCYSjChhsPTjTo0aa5YQhFWSS6vq27yk25SbbbCiiiuY6AooooA//9k=",
	addComponent: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEBLAEsAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCAAXABoDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD+9Cs/VdW0zQtNvdY1m+tdM0vTreS7v7+9mS3tbS2hUvLPPNIQkccagszMQABXx7+074gOk/Ev4J6f4i8c/ErwD8MdT8OfF+48V6x8N7nxRaXcviXTpvhkvgq01K48KaZqt8IpIL7xU1tHLa+Q5ScmVGQBvjW68SXPiP4tp4Q8R+O/if4m/ZBuvHngWOPxX43m8TXl1qnioeGrjUrXw1r134k0/StTt/CMvjO3szJcPZTWz6tb6bpzxC2uWvYQD66uf2tvG5+F2u/HHSfgZDq/wi0Sx8Ua0PFMPxV0SK/v/D/hPU9T0zUNVtdAPhyW4bzpNJuprO1F07XEJiZZMSA19xV+XWqWX7GFv4e17wXL8cvi/p3w5lfxBp+r+ENL1z4lJ8M4LK+1G+l8Q6Ykdp4Um8PJoj38+oLeJHevZKz3AebAYj9RaACud8WeE/D3jjw/qXhbxVplvrGhavCsF9YXIbZIscsc8MkciFZYLi2uIorm1uYHjuLa5iiuIJI5o0dSigD4dm/Zr+PFp8C/EX7Nuh+KPg9b/DTWNI8Z+GbPVb/TPHVz4zstA8YavrOpuXuf7VbS7jU9PTWZLeGeW1kjlEEclwJZGkdv0EoooA//2Q=="
};

export const membershipLevel = {
	standard: 0,
	premium: 1,
	family: 2,
	vip: 3,
	circle: 4,
	supporter: 5,
	captain: 6,
	coach: 7,
	president: 8
};

export const knownRoutes = {
	login: '/login',
	profile: '/profile/my-profile',
	home: '/'
};

export const brightcoveExperienceUrl = "https://players.brightcove.net/6057277724001";
export const stanzaUrl = "https://stanza.co/@ussoccer";

export const allTeams = {
	senior: {
		wnt: `e70zl10x0ayu7y10ry0wi465a`,
		mnt: `9vh2u1p4ppm597tjfahst2m3n`,
	},
	youth: {
		wnt: {
			u23: `be84r8u96b8jh66dwbv9b4qjk`,
			u20: `ec3tww97m7qojokgz53yr44em`,
			u19: `6yklya7m6q6g7xzckv535p7st`,
			u18: `5l3b88l33tcaz7nowyqijflr`,
			u17: `bvwww6axicyq6121pawu2fq7k`,
		},
		mnt: {
			u23: `2vnxw9nc0zq05fdawsdy9mc1n`,
			u20: `bo858sll0r8nayyt5smdu3pxs`,
			u19: `84g9fqkh21a3dakhx4mmrsfl5`,
			u18: `9td0xzs7ekzcyxlq16hcr1kch`,
			u17: `x1zdh3b7nwu0ql0uc5tgic9e`,
		},
	},
};

export const USTeamNames = {
	[allTeams.senior.wnt]: "USWNT",
	[allTeams.senior.mnt]: "USMNT",
	[allTeams.youth.wnt.u23]: "U-23 WNT",
	[allTeams.youth.mnt.u23]: "U-23 MNT",
	[allTeams.youth.wnt.u20]: "U-20 WNT",
	[allTeams.youth.mnt.u20]: "U-20 MNT",
	[allTeams.youth.wnt.u19]: "U-19 WNT",
	[allTeams.youth.mnt.u19]: "U-19 MNT",
	[allTeams.youth.wnt.u18]: "U-18 WNT",
	[allTeams.youth.mnt.u18]: "U-18 MNT",
	[allTeams.youth.wnt.u17]: "U-17 WNT",
	[allTeams.youth.mnt.u17]: "U-17 MNT",
};

export const womensTeams = [
	allTeams.senior.wnt,
	allTeams.youth.wnt.u23,
	allTeams.youth.wnt.u20,
	allTeams.youth.wnt.u19,
	allTeams.youth.wnt.u18,
	allTeams.youth.wnt.u17,
];

export const mensTeams = [
	allTeams.senior.mnt,
	allTeams.youth.mnt.u23,
	allTeams.youth.mnt.u20,
	allTeams.youth.mnt.u19,
	allTeams.youth.mnt.u18,
	allTeams.youth.mnt.u17,
];

export const youthTeams = [
	// Women.
	allTeams.youth.wnt.u23,
	allTeams.youth.wnt.u20,
	allTeams.youth.wnt.u19,
	allTeams.youth.wnt.u18,
	allTeams.youth.wnt.u17,
	allTeams.youth.wnt.u16,
	allTeams.youth.wnt.u15,
	// Men.
	allTeams.youth.mnt.u23,
	allTeams.youth.mnt.u20,
	allTeams.youth.mnt.u19,
	allTeams.youth.mnt.u18,
	allTeams.youth.mnt.u17,
	allTeams.youth.mnt.u16,
	allTeams.youth.mnt.u15,
];

export const cardType = {
	yellow: 0,
	red: 1,
	secondYellow: 2
};

export const validDateTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";